import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-leilao11',
  templateUrl: './leilao11.component.html',
  styleUrls: ['./leilao11.component.scss']
})
export class Leilao11Component implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
  }

  voltar(){
    this.router.navigate([''], { relativeTo: this.route });
  }

}